import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/images/user/user16.jpg'
import _imports_1 from '../../../assets/images/courses/course3.jpg'
import _imports_2 from '../../../assets/images/icon/vue.png'
import _imports_3 from '../../../assets/images/user/user2.jpg'
import _imports_4 from '../../../assets/images/user/user7.jpg'
import _imports_5 from '../../../assets/images/user/user1.jpg'


const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing course-details-card" }
const _hoisted_2 = { class: "card-body p-10" }
const _hoisted_3 = { class: "bg-gradient ps-15 pe-15 pt-20 pb-20 ps-md-30 pe-md-30 pt-md-35 pb-md-35 ps-lg-40 pe-lg-40 pt-lg-50 pb-lg-50" }
const _hoisted_4 = { class: "course-details-header" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<span class=\"d-inline-block bg-warning fs-12 fw-medium rounded-1 ps-10 pe-10 pt-1 pb-1 mb-10 text-black\"> Best Selling </span><h2 class=\"fw-bold text-white\"> Artificial Intelligence A-Z 2024: Build an AI with ChatGPT4 </h2><p class=\"lh-base fs-md-15 fs-lg-16\"> Combine the power of Data Science, Machine Learning and Deep Learning to create powerful AI for Real-World applications! </p><div class=\"info d-sm-flex align-items-center\"><div class=\"reviews d-flex align-items-center\"><div class=\"rating lh-1\"><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i></div><span class=\"fw-bold fs-13 ms-5 me-8 text-white\">4.9</span><span>(21 Reviews)</span></div><div class=\"d-flex align-items-center mt-10 mt-sm-0 ms-sm-15\"><img src=\"" + _imports_0 + "\" class=\"rounded-circle\" width=\"25\" height=\"25\" alt=\"user\"><span class=\"ms-5\">Created by <span>J. Ronan</span></span></div></div>", 4)
const _hoisted_9 = { class: "buttons-list mt-md-15 mt-lg-20" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "fs-14 fw-medium position-relative rounded-1 transition d-inline-block"
}, " Enroll Course ", -1)
const _hoisted_12 = { class: "pe-xxl-25 pe-xxxl-50" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-xxl-8 col-xxxl-9" }
const _hoisted_15 = { class: "pe-xxxl-10" }
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"card-body pt-0 pb-0 ps-10 pe-10\"><div class=\"course-info bg-gray\"><div class=\"row\"><div class=\"col-sm-6 col-lg-3 col-xl-6 col-xxxl-3\"><div class=\"info-card position-relative\"><div class=\"icon bg-info rounded-circle text-center position-absolute start-0 text-white\"><i class=\"flaticon-bar-chart-1\"></i></div><span class=\"d-block text-black-emphasis fs-md-15 fs-lg-16 fw-bold mb-1\"> Course Level: </span><span class=\"fw-medium text-paragraph\">Beginner</span></div></div><div class=\"col-sm-6 col-lg-3 col-xl-6 col-xxxl-3\"><div class=\"info-card position-relative\"><div class=\"icon bg-success rounded-circle text-center position-absolute start-0 text-white\"><i class=\"flaticon-clock\"></i></div><span class=\"d-block text-black-emphasis fs-md-15 fs-lg-16 fw-bold mb-1\"> Course Duration: </span><span class=\"fw-medium text-paragraph\">32 Hours</span></div></div><div class=\"col-sm-6 col-lg-3 col-xl-6 col-xxxl-3\"><div class=\"info-card position-relative\"><div class=\"icon bg-warning rounded-circle text-center position-absolute start-0 text-white\"><i class=\"flaticon-copy\"></i></div><span class=\"d-block text-black-emphasis fs-md-15 fs-lg-16 fw-bold mb-1\"> Total Lessons: </span><span class=\"fw-medium text-paragraph\">24 Lessons</span></div></div><div class=\"col-sm-6 col-lg-3 col-xl-6 col-xxxl-3\"><div class=\"info-card position-relative\"><div class=\"icon bg-danger rounded-circle text-center position-absolute start-0 text-white\"><i class=\"flaticon-people\"></i></div><span class=\"d-block text-black-emphasis fs-md-15 fs-lg-16 fw-bold mb-1\"> Total Students: </span><span class=\"fw-medium text-paragraph\">204</span></div></div></div></div></div>", 1)
const _hoisted_17 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "mb-15 mb-md-20" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title fw-bold mb-0 fs-15 fs-md-16 fs-lg-18" }, " Table Of Content: ")
], -1)
const _hoisted_19 = {
  class: "accordion",
  id: "tableOfContentAccordion"
}
const _hoisted_20 = { class: "accordion-item border-0" }
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<button class=\"accordion-button d-block w-100 text-start text-black fs-14 fs-md-15 fs-lg-16 fw-medium rounded-0 bg-white border-0\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#TableContentCollapseOne\" aria-expanded=\"true\" aria-controls=\"TableContentCollapseOne\"><div class=\"d-sm-flex align-items-center justify-content-between\"><div class=\"d-flex align-items-center\"><div class=\"number bg-primary text-center text-white rounded-circle fs-13 fw-semibold\"> 1 </div> Welcome to the course! </div><ul class=\"d-flex align-items-center mt-10 mt-sm-0 ps-0 mb-0 list-unstyled\"><li class=\"position-relative fw-medium fs-14 text-muted\"><i class=\"flaticon-book\"></i> 5 lectures </li><li class=\"position-relative fw-medium fs-14 text-muted\"><i class=\"flaticon-clock\"></i> 11 mins </li></ul></div></button>", 1)
const _hoisted_22 = {
  id: "TableContentCollapseOne",
  class: "accordion-collapse collapse show",
  "data-bs-parent": "#tableOfContentAccordion"
}
const _hoisted_23 = { class: "accordion-body" }
const _hoisted_24 = { class: "ps-0 mb-0 list-unstyled" }
const _hoisted_25 = { class: "d-flex justify-content-between" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "01:22", -1)
const _hoisted_28 = { class: "d-flex justify-content-between" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "05:10", -1)
const _hoisted_31 = { class: "d-flex justify-content-between" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "00:46", -1)
const _hoisted_34 = { class: "d-flex justify-content-between" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "03:26", -1)
const _hoisted_37 = { class: "d-flex justify-content-between" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "00:23", -1)
const _hoisted_40 = { class: "accordion-item border-0" }
const _hoisted_41 = /*#__PURE__*/_createStaticVNode("<button class=\"accordion-button collapsed d-block w-100 text-start text-black fs-14 fs-md-15 fs-lg-16 fw-medium rounded-0 bg-white border-0\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#TableContentCollapseTwo\" aria-expanded=\"true\" aria-controls=\"TableContentCollapseTwo\"><div class=\"d-sm-flex align-items-center justify-content-between\"><div class=\"d-flex align-items-center\"><div class=\"number bg-primary text-center text-white rounded-circle fs-13 fw-semibold\"> 2 </div> Python Setup </div><ul class=\"d-flex align-items-center mt-10 mt-sm-0 ps-0 mb-0 list-unstyled\"><li class=\"position-relative fw-medium fs-14 text-muted\"><i class=\"flaticon-book\"></i> 6 lectures </li><li class=\"position-relative fw-medium fs-14 text-muted\"><i class=\"flaticon-clock\"></i> 12 mins </li></ul></div></button>", 1)
const _hoisted_42 = {
  id: "TableContentCollapseTwo",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#tableOfContentAccordion"
}
const _hoisted_43 = { class: "accordion-body" }
const _hoisted_44 = { class: "ps-0 mb-0 list-unstyled" }
const _hoisted_45 = { class: "d-flex justify-content-between" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "01:22", -1)
const _hoisted_48 = { class: "d-flex justify-content-between" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "05:10", -1)
const _hoisted_51 = { class: "d-flex justify-content-between" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "00:46", -1)
const _hoisted_54 = { class: "d-flex justify-content-between" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "03:26", -1)
const _hoisted_57 = { class: "d-flex justify-content-between" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "00:23", -1)
const _hoisted_60 = { class: "accordion-item border-0" }
const _hoisted_61 = /*#__PURE__*/_createStaticVNode("<button class=\"accordion-button collapsed d-block w-100 text-start text-black fs-14 fs-md-15 fs-lg-16 fw-medium rounded-0 bg-white border-0\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#TableContentCollapseThree\" aria-expanded=\"true\" aria-controls=\"TableContentCollapseThree\"><div class=\"d-sm-flex align-items-center justify-content-between\"><div class=\"d-flex align-items-center\"><div class=\"number bg-primary text-center text-white rounded-circle fs-13 fw-semibold\"> 3 </div> Python Objects &amp; Data Structures Basics </div><ul class=\"d-flex align-items-center mt-10 mt-sm-0 ps-0 mb-0 list-unstyled\"><li class=\"position-relative fw-medium fs-14 text-muted\"><i class=\"flaticon-book\"></i> 8 lectures </li><li class=\"position-relative fw-medium fs-14 text-muted\"><i class=\"flaticon-clock\"></i> 43 mins </li></ul></div></button>", 1)
const _hoisted_62 = {
  id: "TableContentCollapseThree",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#tableOfContentAccordion"
}
const _hoisted_63 = { class: "accordion-body" }
const _hoisted_64 = { class: "ps-0 mb-0 list-unstyled" }
const _hoisted_65 = { class: "d-flex justify-content-between" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "01:22", -1)
const _hoisted_68 = { class: "d-flex justify-content-between" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "05:10", -1)
const _hoisted_71 = { class: "d-flex justify-content-between" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "00:46", -1)
const _hoisted_74 = { class: "d-flex justify-content-between" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "03:26", -1)
const _hoisted_77 = { class: "d-flex justify-content-between" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "00:23", -1)
const _hoisted_80 = { class: "accordion-item border-0" }
const _hoisted_81 = /*#__PURE__*/_createStaticVNode("<button class=\"accordion-button collapsed d-block w-100 text-start text-black fs-14 fs-md-15 fs-lg-16 fw-medium rounded-0 bg-white border-0\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#TableContentCollapseFour\" aria-expanded=\"true\" aria-controls=\"TableContentCollapseFour\"><div class=\"d-sm-flex align-items-center justify-content-between\"><div class=\"d-flex align-items-center\"><div class=\"number bg-primary text-center text-white rounded-circle fs-13 fw-semibold\"> 4 </div> Python Comparison Operators </div><ul class=\"d-flex align-items-center mt-10 mt-sm-0 ps-0 mb-0 list-unstyled\"><li class=\"position-relative fw-medium fs-14 text-muted\"><i class=\"flaticon-book\"></i> 3 lectures </li><li class=\"position-relative fw-medium fs-14 text-muted\"><i class=\"flaticon-clock\"></i> 33 mins </li></ul></div></button>", 1)
const _hoisted_82 = {
  id: "TableContentCollapseFour",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#tableOfContentAccordion"
}
const _hoisted_83 = { class: "accordion-body" }
const _hoisted_84 = { class: "ps-0 mb-0 list-unstyled" }
const _hoisted_85 = { class: "d-flex justify-content-between" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "01:22", -1)
const _hoisted_88 = { class: "d-flex justify-content-between" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "05:10", -1)
const _hoisted_91 = { class: "d-flex justify-content-between" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_93 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "00:46", -1)
const _hoisted_94 = { class: "d-flex justify-content-between" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_96 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "03:26", -1)
const _hoisted_97 = { class: "d-flex justify-content-between" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_99 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "00:23", -1)
const _hoisted_100 = { class: "accordion-item border-0" }
const _hoisted_101 = /*#__PURE__*/_createStaticVNode("<button class=\"accordion-button collapsed d-block w-100 text-start text-black fs-14 fs-md-15 fs-lg-16 fw-medium rounded-0 bg-white border-0\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#TableContentCollapseFive\" aria-expanded=\"true\" aria-controls=\"TableContentCollapseFive\"><div class=\"d-sm-flex align-items-center justify-content-between\"><div class=\"d-flex align-items-center\"><div class=\"number bg-primary text-center text-white rounded-circle fs-13 fw-semibold\"> 5 </div> Python Statements </div><ul class=\"d-flex align-items-center mt-10 mt-sm-0 ps-0 mb-0 list-unstyled\"><li class=\"position-relative fw-medium fs-14 text-muted\"><i class=\"flaticon-book\"></i> 10 lectures </li><li class=\"position-relative fw-medium fs-14 text-muted\"><i class=\"flaticon-clock\"></i> 1 hour </li></ul></div></button>", 1)
const _hoisted_102 = {
  id: "TableContentCollapseFive",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#tableOfContentAccordion"
}
const _hoisted_103 = { class: "accordion-body" }
const _hoisted_104 = { class: "ps-0 mb-0 list-unstyled" }
const _hoisted_105 = { class: "d-flex justify-content-between" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_107 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "01:22", -1)
const _hoisted_108 = { class: "d-flex justify-content-between" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_110 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "05:10", -1)
const _hoisted_111 = { class: "d-flex justify-content-between" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_113 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "00:46", -1)
const _hoisted_114 = { class: "d-flex justify-content-between" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_116 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "03:26", -1)
const _hoisted_117 = { class: "d-flex justify-content-between" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play" }, null, -1)
const _hoisted_119 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-medium" }, "00:23", -1)
const _hoisted_120 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "show-more-btn d-block w-100 fw-medium text-center mt-15 mt-md-20 ps-15 pe-15 pt-12 pb-12 pt-md-15 pb-md-15 pt-lg-20 pb-lg-20 transition"
}, " View All Sections ", -1)
const _hoisted_121 = { class: "col-xxl-4 col-xxxl-3" }
const _hoisted_122 = { class: "ps-10 ps-xxl-0 pe-10" }
const _hoisted_123 = /*#__PURE__*/_createStaticVNode("<div class=\"mb-25 course-details-info bg-gray\"><img src=\"" + _imports_1 + "\" alt=\"course-image\"><div class=\"p-15 p-md-25\"><div class=\"mb-15 price d-flex align-items-end\"><span class=\"text-primary lh-1 fw-bold fs-16 fs-md-20 fs-lg-25\">$250</span><span class=\"text-muted fs-13 fw-medium ms-5 me-8 text-decoration-line-through\">$350</span><span class=\"text-success fw-medium\"><span class=\"fw-black\">60%</span> Off</span></div><span class=\"d-block text-black fs-md-15 fs-lg-16 mb-8\">This Course Includes:</span><ul class=\"ps-0 list-unstyled mb-0\"><li class=\"fs-md-15 fs-lg-16 text-muted position-relative\"><i class=\"flaticon-book\"></i><span class=\"text-black\">15</span> On demand video classes </li><li class=\"fs-md-15 fs-lg-16 text-muted position-relative\"><i class=\"flaticon-book\"></i><span class=\"text-black\">Full</span> Lifetime Access </li><li class=\"fs-md-15 fs-lg-16 text-muted position-relative\"><i class=\"flaticon-book\"></i><span class=\"text-black\">37</span> Hrs on demand projects </li><li class=\"fs-md-15 fs-lg-16 text-muted position-relative\"><i class=\"flaticon-book\"></i><span class=\"text-black\">Certificate</span> On completion </li></ul><button class=\"default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 d-block w-100 mt-12 mt-md-20\" type=\"submit\"> Buy This Course </button></div></div><span class=\"d-block fs-15 fs-md-16 fs-lg-18 fw-bold text-black mb-12 mb-md-15\">Related Course</span>", 2)
const _hoisted_125 = { class: "card mb-25 border-0 rounded-0 letter-spacing courses-list-box" }
const _hoisted_126 = /*#__PURE__*/_createStaticVNode("<div class=\"card-body\"><div class=\"title position-relative mb-8 mb-md-10\"><div class=\"icon bg-primary text-center rounded-circle position-relative\"><img src=\"" + _imports_2 + "\" class=\"position-absolute start-0 end-0 ms-auto me-auto\" alt=\"icon\"></div><h6 class=\"mb-0 text-black fw-bold\"> Fundamental Vue 3 JS Framework Course </h6></div><p class=\"fs-md-15 fs-lg-16 text-black-emphasis mb-15\"> Solve your coding problems in this course with mentors </p><ul class=\"list ps-0 mb-0 list-unstyled\"><li class=\"d-inline-block bg-white fs-13 text-muted fw-medium\"><span class=\"fw-bold text-primary\">45</span> Lessons </li><li class=\"d-inline-block bg-white fs-13 text-muted fw-medium\"><span class=\"fw-bold text-primary\">71</span> Students </li><li class=\"d-inline-block bg-white fs-13 text-muted fw-medium\"><span class=\"fw-bold text-primary\">59</span> Mins </li></ul></div>", 1)
const _hoisted_127 = /*#__PURE__*/_createElementVNode("span", { class: "d-inline-block position-relative" }, " View Details ", -1)
const _hoisted_128 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-arrow-right" }, null, -1)
const _hoisted_129 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 col-xxxl-6" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card mb-25 border-0 rounded-0 bg-white course-details-card" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "mb-12 mb-lg-15" }, [
          /*#__PURE__*/_createElementVNode("h5", { class: "card-title fw-bold mb-0 fs-15 fs-md-16 fs-lg-18" }, " About The Course ")
        ]),
        /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph fs-md-15 fs-lg-16 text-paragraph lh-base" }, " Combine the power of Data Science, Machine Learning and Deep Learning to create powerful AI for Real-World applications! "),
        /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph fs-md-15 fs-lg-16 text-paragraph lh-base" }, " We’re fully committed to making this the most accessible and results-driven AI course on the planet. This requires us to be there when you need our help. That’s why we’ve put together a team of professional Data Scientists to support you in your journey, meaning you’ll get a response from us within 48 hours maximum. "),
        /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph fs-md-15 fs-lg-16 text-paragraph lh-base" }, " Learn key AI concepts and intuition training to get you quickly up to speed with all things AI. ")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 col-xxxl-3" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card mb-25 border-0 rounded-0 bg-white course-details-card" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "mb-15 mb-lg-20" }, [
          /*#__PURE__*/_createElementVNode("h5", { class: "card-title fw-bold mb-0 fs-15 fs-md-16 fs-lg-18" }, " What You Will Learn ")
        ]),
        /*#__PURE__*/_createElementVNode("ul", { class: "what-you-will-learn ps-0 mb-0 list-unstyled" }, [
          /*#__PURE__*/_createElementVNode("li", { class: "text-paragraph fs-md-15 fs-lg-16 fw-medium position-relative" }, [
            /*#__PURE__*/_createElementVNode("i", { class: "flaticon-check-mark-1" }),
            /*#__PURE__*/_createTextVNode(" Complete beginner to expert AI skill ")
          ]),
          /*#__PURE__*/_createElementVNode("li", { class: "text-paragraph fs-md-15 fs-lg-16 fw-medium position-relative" }, [
            /*#__PURE__*/_createElementVNode("i", { class: "flaticon-check-mark-1" }),
            /*#__PURE__*/_createTextVNode(" Using ChatGPT for coding ")
          ]),
          /*#__PURE__*/_createElementVNode("li", { class: "text-paragraph fs-md-15 fs-lg-16 fw-medium position-relative" }, [
            /*#__PURE__*/_createElementVNode("i", { class: "flaticon-check-mark-1" }),
            /*#__PURE__*/_createTextVNode(" Real world solution ")
          ]),
          /*#__PURE__*/_createElementVNode("li", { class: "text-paragraph fs-md-15 fs-lg-16 fw-medium position-relative" }, [
            /*#__PURE__*/_createElementVNode("i", { class: "flaticon-check-mark-1" }),
            /*#__PURE__*/_createTextVNode(" How to optimize your AI ")
          ]),
          /*#__PURE__*/_createElementVNode("li", { class: "text-paragraph fs-md-15 fs-lg-16 fw-medium position-relative" }, [
            /*#__PURE__*/_createElementVNode("i", { class: "flaticon-check-mark-1" }),
            /*#__PURE__*/_createTextVNode(" How to start building AI ")
          ]),
          /*#__PURE__*/_createElementVNode("li", { class: "text-paragraph fs-md-15 fs-lg-16 fw-medium position-relative" }, [
            /*#__PURE__*/_createElementVNode("i", { class: "flaticon-check-mark-1" }),
            /*#__PURE__*/_createTextVNode(" How to merge AI with OpenAI Gym ")
          ])
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 col-xxxl-3" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card mb-25 border-0 rounded-0 bg-white course-details-card" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "mb-15 mb-lg-20" }, [
          /*#__PURE__*/_createElementVNode("h5", { class: "card-title fw-bold mb-0 fs-15 fs-md-16 fs-lg-18" }, " Who This Course Is For ")
        ]),
        /*#__PURE__*/_createElementVNode("ul", { class: "what-you-will-learn ps-0 mb-0 list-unstyled" }, [
          /*#__PURE__*/_createElementVNode("li", { class: "text-paragraph fs-md-15 fs-lg-16 fw-medium position-relative" }, [
            /*#__PURE__*/_createElementVNode("i", { class: "flaticon-check-mark-1" }),
            /*#__PURE__*/_createTextVNode(" Anyone interested in Artificial Intelligence, Machine Learning or Deep Learning ")
          ]),
          /*#__PURE__*/_createElementVNode("li", { class: "text-paragraph fs-md-15 fs-lg-16 fw-medium position-relative" }, [
            /*#__PURE__*/_createElementVNode("i", { class: "flaticon-check-mark-1" }),
            /*#__PURE__*/_createTextVNode(" Who have high school math skill ")
          ]),
          /*#__PURE__*/_createElementVNode("li", { class: "text-paragraph fs-md-15 fs-lg-16 fw-medium position-relative" }, [
            /*#__PURE__*/_createElementVNode("i", { class: "flaticon-check-mark-1" }),
            /*#__PURE__*/_createTextVNode(" Who have basic Python knowledge ")
          ])
        ]),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("br")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-xxl-8" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card mb-25 border-0 rounded-0 bg-white course-details-card" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "mb-15 mb-md-20" }, [
          /*#__PURE__*/_createElementVNode("h5", { class: "card-title fw-bold mb-0 fs-15 fs-md-16 fs-lg-18" }, " About The Author ")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "row align-items-center about-the-author" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3 col-sm-3" }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_0,
              class: "rounded-circle",
              alt: "author"
            })
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col-lg-9 col-sm-9" }, [
            /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black fs-15 fs-md-16 fs-lg-18 fw-semibold mb-5 mt-20 mt-sm-0" }, "Jonathon Ronan"),
            /*#__PURE__*/_createElementVNode("span", { class: "d-block text-muted fs-md-15 mb-10" }, "Senior AI Advisor & Cybersecurity Engineer"),
            /*#__PURE__*/_createElementVNode("div", { class: "reviews d-flex align-items-center mb-10 mb-lg-15" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "rating lh-1" }, [
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" })
              ]),
              /*#__PURE__*/_createElementVNode("span", { class: "text-black fw-bold fs-13 ms-5 me-8" }, "4.9"),
              /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "(21 Instructor Ratings)")
            ]),
            /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph fs-md-15 fs-lg-16 lh-base" }, " I'm a Senior AI Advisor, AI & Cybersecurity Engineer, and also the founder of Global Pioneers & the Threat Intelligence Group. My goal is to help provide my experiences and expertise that have been obtained through extensive research, many late nights, and cups of coffee. ")
          ])
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "card mb-25 border-0 rounded-0 bg-white course-details-card" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "mb-15 mb-md-20 mb-lg-25" }, [
          /*#__PURE__*/_createElementVNode("h5", { class: "card-title fw-bold mb-0 fs-15 fs-md-16 fs-lg-18" }, " Students Feedback ")
        ]),
        /*#__PURE__*/_createElementVNode("ul", { class: "students-feedback-list ps-0 mb-0 list-unstyled" }, [
          /*#__PURE__*/_createElementVNode("li", { class: "position-relative" }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_3,
              width: "40",
              height: "40",
              class: "rounded-circle",
              alt: "user"
            }),
            /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black fs-15 fs-md-16 fs-lg-18 fw-semibold mb-5" }, "Angela Carter"),
            /*#__PURE__*/_createElementVNode("div", { class: "reviews d-flex align-items-center mb-10 mb-lg-15" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "rating lh-1" }, [
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" })
              ]),
              /*#__PURE__*/_createElementVNode("span", { class: "text-black fw-bold fs-13 ms-5 me-8" }, "5.0"),
              /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "2 days ago")
            ]),
            /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph fs-md-15 fs-lg-16 lh-base" }, " A great and deep introduction to reinforcement learning (don't get baited by the title which tells not much about the content of the course). I particularly liked the way of introducing the basic concepts/model and progressively add complexity to discover more convoluted models. ")
          ]),
          /*#__PURE__*/_createElementVNode("li", { class: "position-relative" }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_4,
              width: "40",
              height: "40",
              class: "rounded-circle",
              alt: "user"
            }),
            /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black fs-15 fs-md-16 fs-lg-18 fw-semibold mb-5" }, "Victor James"),
            /*#__PURE__*/_createElementVNode("div", { class: "reviews d-flex align-items-center mb-10 mb-lg-15" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "rating lh-1" }, [
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star" })
              ]),
              /*#__PURE__*/_createElementVNode("span", { class: "text-black fw-bold fs-13 ms-5 me-8" }, "4.0"),
              /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "3 days ago")
            ]),
            /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph fs-md-15 fs-lg-16 lh-base" }, " A great and deep introduction to reinforcement learning (don't get baited by the title which tells not much about the content of the course). I particularly liked the way of introducing the basic concepts/model and progressively add complexity to discover more convoluted models. ")
          ]),
          /*#__PURE__*/_createElementVNode("li", { class: "position-relative" }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_5,
              width: "40",
              height: "40",
              class: "rounded-circle",
              alt: "user"
            }),
            /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black fs-15 fs-md-16 fs-lg-18 fw-semibold mb-5" }, "Walter White"),
            /*#__PURE__*/_createElementVNode("div", { class: "reviews d-flex align-items-center mb-10 mb-lg-15" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "rating lh-1" }, [
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-2" })
              ]),
              /*#__PURE__*/_createElementVNode("span", { class: "text-black fw-bold fs-13 ms-5 me-8" }, "4.5"),
              /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "4 days ago")
            ]),
            /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph fs-md-15 fs-lg-16 lh-base" }, " A great and deep introduction to reinforcement learning (don't get baited by the title which tells not much about the content of the course). I particularly liked the way of introducing the basic concepts/model and progressively add complexity to discover more convoluted models. ")
          ])
        ]),
        /*#__PURE__*/_createElementVNode("button", {
          type: "button",
          class: "show-more-btn d-block w-100 fw-medium text-center mt-15 mt-sm-20 mt-md-25 mt-lg-30 ps-15 pe-15 pt-12 pb-12 pt-md-15 pb-md-15 pt-lg-20 pb-lg-20 transition"
        }, " Show All Reviews ")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-xxl-4" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing manage-reviews-box" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "card-body p-15 p-sm-20 p-md-25" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "mb-15 mb-md-20" }, [
          /*#__PURE__*/_createElementVNode("h5", { class: "card-title fw-bold mb-0 fs-15 fs-md-16 fs-lg-18" }, " Course Rating ")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "box mb-20 mb-md-25 d-flex align-items-center justify-content-between p-12 p-sm-15 p-md-20" }, [
          /*#__PURE__*/_createElementVNode("div", null, [
            /*#__PURE__*/_createElementVNode("span", { class: "d-block text-paragraph fs-md-15 fs-lg-16 mb-1" }, "Average Ratings"),
            /*#__PURE__*/_createElementVNode("span", { class: "d-block text-paragraph fs-md-15 fs-lg-16" }, [
              /*#__PURE__*/_createTextVNode("Out Of "),
              /*#__PURE__*/_createElementVNode("span", { class: "text-black fw-medium" }, "67"),
              /*#__PURE__*/_createTextVNode(" Ratings")
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "text-primary fw-black fs-20 fs-md-25 fs-lg-30" }, " 4.86 ")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "manage-rating" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "row mt-15" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "col-5 col-sm-4 col-xxxl-3" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "rating" }, [
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" })
              ]),
              /*#__PURE__*/_createElementVNode("span", { class: "d-block text-paragraph" }, [
                /*#__PURE__*/_createElementVNode("span", { class: "text-black fw-medium" }, "46"),
                /*#__PURE__*/_createTextVNode(" Reviews")
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "col-7 col-sm-8 col-xxxl-9" }, [
              /*#__PURE__*/_createElementVNode("div", {
                class: "progress",
                role: "progressbar",
                "aria-valuenow": "65",
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }, [
                /*#__PURE__*/_createElementVNode("div", {
                  class: "progress-bar",
                  style: {"width":"65%"}
                })
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "row mt-15" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "col-5 col-sm-4 col-xxxl-3" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "rating" }, [
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star" })
              ]),
              /*#__PURE__*/_createElementVNode("span", { class: "d-block text-paragraph" }, [
                /*#__PURE__*/_createElementVNode("span", { class: "text-black fw-medium" }, "12"),
                /*#__PURE__*/_createTextVNode(" Reviews")
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "col-7 col-sm-8 col-xxxl-9" }, [
              /*#__PURE__*/_createElementVNode("div", {
                class: "progress",
                role: "progressbar",
                "aria-valuenow": "35",
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }, [
                /*#__PURE__*/_createElementVNode("div", {
                  class: "progress-bar",
                  style: {"width":"35%"}
                })
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "row mt-15" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "col-5 col-sm-4 col-xxxl-3" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "rating" }, [
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star" })
              ]),
              /*#__PURE__*/_createElementVNode("span", { class: "d-block text-paragraph" }, [
                /*#__PURE__*/_createElementVNode("span", { class: "text-black fw-medium" }, "09"),
                /*#__PURE__*/_createTextVNode(" Reviews")
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "col-7 col-sm-8 col-xxxl-9" }, [
              /*#__PURE__*/_createElementVNode("div", {
                class: "progress",
                role: "progressbar",
                "aria-valuenow": "20",
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }, [
                /*#__PURE__*/_createElementVNode("div", {
                  class: "progress-bar",
                  style: {"width":"20%"}
                })
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "row mt-15" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "col-5 col-sm-4 col-xxxl-3" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "rating" }, [
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star" })
              ]),
              /*#__PURE__*/_createElementVNode("span", { class: "d-block text-paragraph" }, [
                /*#__PURE__*/_createElementVNode("span", { class: "text-black fw-medium" }, "0"),
                /*#__PURE__*/_createTextVNode(" Reviews")
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "col-7 col-sm-8 col-xxxl-9" }, [
              /*#__PURE__*/_createElementVNode("div", {
                class: "progress",
                role: "progressbar",
                "aria-valuenow": "0",
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }, [
                /*#__PURE__*/_createElementVNode("div", {
                  class: "progress-bar",
                  style: {"width":"0%"}
                })
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "row mt-15" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "col-5 col-sm-4 col-xxxl-3" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "rating" }, [
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star-1" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star" }),
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-star" })
              ]),
              /*#__PURE__*/_createElementVNode("span", { class: "d-block text-paragraph" }, [
                /*#__PURE__*/_createElementVNode("span", { class: "text-black fw-medium" }, "0"),
                /*#__PURE__*/_createTextVNode(" Reviews")
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "col-7 col-sm-8 col-xxxl-9" }, [
              /*#__PURE__*/_createElementVNode("div", {
                class: "progress",
                role: "progressbar",
                "aria-valuenow": "0",
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }, [
                /*#__PURE__*/_createElementVNode("div", {
                  class: "progress-bar",
                  style: {"width":"0%"}
                })
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_VideoModal = _resolveComponent("VideoModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                type: "button",
                class: "fs-14 fw-medium position-relative rounded-1 transition d-inline-block with-icon",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.stateStoreInstance.videoModal && $setup.stateStoreInstance.videoModal(...args)))
              }, [
                _createTextVNode(" Watch Preview "),
                _hoisted_10
              ]),
              _hoisted_11
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("ul", _hoisted_24, [
                          _createElementVNode("li", _hoisted_25, [
                            _createVNode(_component_router_link, {
                              to: "/lessons-preview",
                              class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_26,
                                _createTextVNode(" Welcome Challenge! ")
                              ]),
                              _: 1
                            }),
                            _hoisted_27
                          ]),
                          _createElementVNode("li", _hoisted_28, [
                            _createVNode(_component_router_link, {
                              to: "/lessons-preview",
                              class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_29,
                                _createTextVNode(" Why AI? ")
                              ]),
                              _: 1
                            }),
                            _hoisted_30
                          ]),
                          _createElementVNode("li", _hoisted_31, [
                            _createVNode(_component_router_link, {
                              to: "/lessons-preview",
                              class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_32,
                                _createTextVNode(" Course Structure ")
                              ]),
                              _: 1
                            }),
                            _hoisted_33
                          ]),
                          _createElementVNode("li", _hoisted_34, [
                            _createVNode(_component_router_link, {
                              to: "/lessons-preview",
                              class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_35,
                                _createTextVNode(" Installing Anaconda ")
                              ]),
                              _: 1
                            }),
                            _hoisted_36
                          ]),
                          _createElementVNode("li", _hoisted_37, [
                            _createVNode(_component_router_link, {
                              to: "/lessons-preview",
                              class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_38,
                                _createTextVNode(" Use ChatGPT to Build AI More Efficiently ")
                              ]),
                              _: 1
                            }),
                            _hoisted_39
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("ul", _hoisted_44, [
                          _createElementVNode("li", _hoisted_45, [
                            _createVNode(_component_router_link, {
                              to: "/lessons-preview",
                              class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_46,
                                _createTextVNode(" Welcome Challenge! ")
                              ]),
                              _: 1
                            }),
                            _hoisted_47
                          ]),
                          _createElementVNode("li", _hoisted_48, [
                            _createVNode(_component_router_link, {
                              to: "/lessons-preview",
                              class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_49,
                                _createTextVNode(" Why AI? ")
                              ]),
                              _: 1
                            }),
                            _hoisted_50
                          ]),
                          _createElementVNode("li", _hoisted_51, [
                            _createVNode(_component_router_link, {
                              to: "/lessons-preview",
                              class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_52,
                                _createTextVNode(" Course Structure ")
                              ]),
                              _: 1
                            }),
                            _hoisted_53
                          ]),
                          _createElementVNode("li", _hoisted_54, [
                            _createVNode(_component_router_link, {
                              to: "/lessons-preview",
                              class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_55,
                                _createTextVNode(" Installing Anaconda ")
                              ]),
                              _: 1
                            }),
                            _hoisted_56
                          ]),
                          _createElementVNode("li", _hoisted_57, [
                            _createVNode(_component_router_link, {
                              to: "/lessons-preview",
                              class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_58,
                                _createTextVNode(" Use ChatGPT to Build AI More Efficiently ")
                              ]),
                              _: 1
                            }),
                            _hoisted_59
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_60, [
                    _hoisted_61,
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("ul", _hoisted_64, [
                          _createElementVNode("li", _hoisted_65, [
                            _createVNode(_component_router_link, {
                              to: "/lessons-preview",
                              class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_66,
                                _createTextVNode(" Welcome Challenge! ")
                              ]),
                              _: 1
                            }),
                            _hoisted_67
                          ]),
                          _createElementVNode("li", _hoisted_68, [
                            _createVNode(_component_router_link, {
                              to: "/lessons-preview",
                              class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_69,
                                _createTextVNode(" Why AI? ")
                              ]),
                              _: 1
                            }),
                            _hoisted_70
                          ]),
                          _createElementVNode("li", _hoisted_71, [
                            _createVNode(_component_router_link, {
                              to: "/lessons-preview",
                              class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_72,
                                _createTextVNode(" Course Structure ")
                              ]),
                              _: 1
                            }),
                            _hoisted_73
                          ]),
                          _createElementVNode("li", _hoisted_74, [
                            _createVNode(_component_router_link, {
                              to: "/lessons-preview",
                              class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_75,
                                _createTextVNode(" Installing Anaconda ")
                              ]),
                              _: 1
                            }),
                            _hoisted_76
                          ]),
                          _createElementVNode("li", _hoisted_77, [
                            _createVNode(_component_router_link, {
                              to: "/lessons-preview",
                              class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_78,
                                _createTextVNode(" Use ChatGPT to Build AI More Efficiently ")
                              ]),
                              _: 1
                            }),
                            _hoisted_79
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_80, [
                    _hoisted_81,
                    _createElementVNode("div", _hoisted_82, [
                      _createElementVNode("div", _hoisted_83, [
                        _createElementVNode("ul", _hoisted_84, [
                          _createElementVNode("li", _hoisted_85, [
                            _createVNode(_component_router_link, {
                              to: "/lessons-preview",
                              class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_86,
                                _createTextVNode(" Welcome Challenge! ")
                              ]),
                              _: 1
                            }),
                            _hoisted_87
                          ]),
                          _createElementVNode("li", _hoisted_88, [
                            _createVNode(_component_router_link, {
                              to: "/lessons-preview",
                              class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_89,
                                _createTextVNode(" Why AI? ")
                              ]),
                              _: 1
                            }),
                            _hoisted_90
                          ]),
                          _createElementVNode("li", _hoisted_91, [
                            _createVNode(_component_router_link, {
                              to: "/lessons-preview",
                              class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_92,
                                _createTextVNode(" Course Structure ")
                              ]),
                              _: 1
                            }),
                            _hoisted_93
                          ]),
                          _createElementVNode("li", _hoisted_94, [
                            _createVNode(_component_router_link, {
                              to: "/lessons-preview",
                              class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_95,
                                _createTextVNode(" Installing Anaconda ")
                              ]),
                              _: 1
                            }),
                            _hoisted_96
                          ]),
                          _createElementVNode("li", _hoisted_97, [
                            _createVNode(_component_router_link, {
                              to: "/lessons-preview",
                              class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_98,
                                _createTextVNode(" Use ChatGPT to Build AI More Efficiently ")
                              ]),
                              _: 1
                            }),
                            _hoisted_99
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_100, [
                    _hoisted_101,
                    _createElementVNode("div", _hoisted_102, [
                      _createElementVNode("div", _hoisted_103, [
                        _createElementVNode("ul", _hoisted_104, [
                          _createElementVNode("li", _hoisted_105, [
                            _createVNode(_component_router_link, {
                              to: "/lessons-preview",
                              class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_106,
                                _createTextVNode(" Welcome Challenge! ")
                              ]),
                              _: 1
                            }),
                            _hoisted_107
                          ]),
                          _createElementVNode("li", _hoisted_108, [
                            _createVNode(_component_router_link, {
                              to: "/lessons-preview",
                              class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_109,
                                _createTextVNode(" Why AI? ")
                              ]),
                              _: 1
                            }),
                            _hoisted_110
                          ]),
                          _createElementVNode("li", _hoisted_111, [
                            _createVNode(_component_router_link, {
                              to: "/lessons-preview",
                              class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_112,
                                _createTextVNode(" Course Structure ")
                              ]),
                              _: 1
                            }),
                            _hoisted_113
                          ]),
                          _createElementVNode("li", _hoisted_114, [
                            _createVNode(_component_router_link, {
                              to: "/lessons-preview",
                              class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_115,
                                _createTextVNode(" Installing Anaconda ")
                              ]),
                              _: 1
                            }),
                            _hoisted_116
                          ]),
                          _createElementVNode("li", _hoisted_117, [
                            _createVNode(_component_router_link, {
                              to: "/lessons-preview",
                              class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_118,
                                _createTextVNode(" Use ChatGPT to Build AI More Efficiently ")
                              ]),
                              _: 1
                            }),
                            _hoisted_119
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _hoisted_120
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_121, [
            _createElementVNode("div", _hoisted_122, [
              _hoisted_123,
              _createElementVNode("div", _hoisted_125, [
                _hoisted_126,
                _createVNode(_component_router_link, {
                  to: "/course-details",
                  class: "link-btn d-block text-decoration-none text-primary fw-medium position-relative"
                }, {
                  default: _withCtx(() => [
                    _hoisted_127,
                    _hoisted_128
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    _hoisted_129,
    _createVNode(_component_VideoModal)
  ]))
}